import { render, staticRenderFns } from "./uploadFileProduct.vue?vue&type=template&id=1127bdd2&scoped=true&"
import script from "./uploadFileProduct.vue?vue&type=script&lang=js&"
export * from "./uploadFileProduct.vue?vue&type=script&lang=js&"
import style0 from "./uploadFileProduct.vue?vue&type=style&index=0&id=1127bdd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127bdd2",
  null
  
)

export default component.exports